import { useState } from "react";
import {
  RequestUpdateAmazonInfoRequest,
  UsersUpdateAmazonInfoPostRequest,
  UsersApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdateAmazonInfo = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateAmazonInfo = async (req: RequestUpdateAmazonInfoRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersUpdateAmazonInfoPostRequest = {
        req,
      };

      const api = new UsersApi(config);
      const response = await api.usersUpdateAmazonInfoPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateAmazonInfo, result, setResult, error, isLoading };
};
